import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Modal, DatePicker, Alert } from 'antd'
import moment from 'moment'
import { getCookie } from 'helper/cookie'
import { saveHolidayDetail, updateHolidayDetail } from 'api/Admin/holiday'
import lang from 'lang/en'
import TextArea from 'antd/lib/input/TextArea'
import { getDataCompany } from 'api/Admin/company'
const initalState = {
  data: [],
  isLoading: true,
}
const AddTaskKPIFinance = (props) => {
  const {
    setvisible,
    visible,
    dataAddEdit,
    infoUser,
    today,
    setCheckChangeTable,
    checkChangeTable,
    company_id,
    operation_id,
    suboperation_id,
    permissionPage,
  } = props
  const language = getCookie('lang')
  const word = lang[language]

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  //detailcompany
  const [nameCompany, setNameCompany] = useState()
  const [nameOperation, setNameOperation] = useState()
  const [nameSubOperation, setNameSubOperation] = useState()

  //dateHoliday
  const [dateHoliday, setDateHoliday] = useState('')
  const [form] = Form.useForm()

  //check วัน ซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const getOptionCompany = async () => {
    await getDataCompany({
      token: token,
      level: 1,
      level_id: 0,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setNameCompany([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (company_id == item.id) {
              if (language == 'en') {
                setNameCompany(item.code + ' ' + item.name_en)
              } else {
                setNameCompany(item.code + ' ' + item.name_th)
              }
            }
          })
        } else {
          setNameCompany([])

          return true
        }
      })
      .catch((error) => {
        setNameCompany([])

        console.error(error)
      })
  }

  const getOptionOperation = async () => {
    await getDataCompany({
      token: token,
      level: 2,
      level_id: company_id,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setNameOperation([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (operation_id == item.id) {
              if (language == 'en') {
                setNameOperation(item.code + ' ' + item.name_en)
              } else {
                setNameOperation(item.code + ' ' + item.name_th)
              }
            }
          })
        } else {
          setNameOperation([])

          return true
        }
      })
      .catch((error) => {
        setNameOperation([])

        console.error(error)
      })
  }

  const getOptionSubOperation = async () => {
    await getDataCompany({
      token: token,
      level: 3,
      level_id: operation_id,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setNameSubOperation([])

          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (suboperation_id == item.id) {
              if (language == 'en') {
                setNameSubOperation(item.code + ' ' + item.name_en)
              } else {
                setNameSubOperation(item.code + ' ' + item.name_th)
              }
            }
          })
        } else {
          setNameSubOperation([])

          return true
        }
      })
      .catch((error) => {
        setNameSubOperation([])
        // setIsLoading(false)
        console.error(error)
      })
  }

  const SetField = () => {
    if (dataAddEdit.state == 'add') {
      form.setFieldsValue({
        company_code: nameCompany,
        operation_code: nameOperation,
        sub_operation_code: nameSubOperation,
        create_date: moment(`${today}`, 'YYYY-MM-DD'),
        last_update_date: moment(`${today}`, 'YYYY-MM-DD'),
        create_by: infoUser.firstname + ' ' + infoUser.lastname,
        english_holiday_name: null,
        local_holiday_name: null,
        remark: null,
        holiday_date: null,
      })
    } else {
      permissionPage.update ? setDisablePage(false) : setDisablePage(true)
      if (dataAddEdit.dataEdit) {
        setDateHoliday(dataAddEdit.dataEdit.holiday_date)
        form.setFieldsValue({
          company_code: nameCompany,
          operation_code: nameOperation,
          sub_operation_code: nameSubOperation,
          create_date: moment(`${today}`, 'YYYY-MM-DD'),
          last_update_date: moment(`${dataAddEdit.dataEdit.updated_at}`, 'YYYY-MM-DD'),
          create_by: infoUser.firstname + ' ' + infoUser.lastname,
          english_holiday_name: dataAddEdit.dataEdit.name_en,
          local_holiday_name: dataAddEdit.dataEdit.name,
          remark: dataAddEdit.dataEdit.remark,
          holiday_date: moment(`${dataAddEdit.dataEdit.holiday_date}`, 'YYYY-MM-DD'),
        })
      }
    }
  }

  useEffect(() => {
    getOptionCompany()
    getOptionOperation()
    getOptionSubOperation()
  }, [checkChangeTable])

  useEffect(() => {
    if (visible == true) {
      SetField()
    } else {
      setFieldNull()
    }
  }, [visible])

  let oktext = ''
  let titleword = ''
  if (dataAddEdit.state == 'add') {
    oktext = word['Save']
    titleword = word['Add']
  } else {
    oktext = word['Update']
    titleword = word['Edit']
  }

  const onFinish = (value) => {
    if (!value.remark) {
      value.remark = ''
    }
    if (dataAddEdit.state == 'add') {
      const dataArray = {
        holiday_id: dataAddEdit.idHoliday,
        holiday_date: dateHoliday,
        name: value.local_holiday_name,
        name_en: value.english_holiday_name,
        remark: value.remark,
      }
      try {
        saveHolidayDetail({
          params: dataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setvisible(false)
            setCheckChangeTable(checkChangeTable + 1)
            setFieldNull()
            setHiddenError(true)
          } else {
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const dataArray2 = {
        holiday_id: dataAddEdit.idHoliday,
        holiday_date: dateHoliday,
        name: value.local_holiday_name,
        name_en: value.english_holiday_name,
        remark: value.remark,
      }
      try {
        updateHolidayDetail({
          params: dataArray2,
          token: token,
          idHolidayDetail: dataAddEdit.dataEdit.id,
        }).then((res) => {
          const { status, data, error } = res

          if (res.status === 200) {
            setvisible(false)
            setCheckChangeTable(checkChangeTable + 1)
            setFieldNull()
            setHiddenError(true)
          } else {
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onChangeHolidaydate = (e, value) => {
    setDateHoliday(value)
  }

  const setFieldNull = () => {
    form.setFieldsValue({
      company_code: null,
      operation_code: null,
      sub_operation_code: null,
      create_date: null,
      last_update_date: null,
      create_by: null,
      english_holiday_name: null,
      local_holiday_name: null,
      remark: null,
      holiday_date: null,
    })
  }

  const onClose = () => {
    setvisible(false)
    setFieldNull()
    setHiddenError(true)
  }

  return (
    <Modal
      maskClosable={false}
      title={
        <h2 className="Modaltitle">
          {titleword} {word['Holiday_Detail']}
        </h2>
      }
      visible={visible}
      destroyOnClose
      onOk={form.submit}
      onCancel={() => onClose()}
      okText={oktext}
      okButtonProps={{ hidden: permissionPage.update ? false : true }}
      className="editmodal edit-width2"
    >
      <Form form={form} layout="vertical" onFinish={onFinish} className="disable-page">
        <fieldset disabled={disablePage}>
          <div hidden={hiddenError}>
            <Alert
              style={{ marginBottom: 10 }}
              message={word['Holiday_date_already_exists']}
              type="error"
              showIcon
            />
          </div>

          <Row gutter={16}>
            <Col span={12} style={{ minWidth: '100%' }}>
              <Form.Item name="company_code" label={word['Business_Code']}>
                <Input
                  disabled
                  id="company_code"
                  size="large"
                  placeholder="Business Code"
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="operation_code" label={word['Operation_Code']}>
                <Input
                  disabled
                  id="operation_code"
                  size="large"
                  placeholder="Operation Code"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="sub_operation_code" label={word['Sub_Operation_Code']}>
                <Input
                  disabled
                  id="sub_operation_code"
                  size="large"
                  placeholder="Project type Code"
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="holiday_date"
                label={word['Holiday_date']}
                rules={[{ required: true, message: 'Please enter holiday date' }]}
              >
                <DatePicker
                  disabled={disablePage}
                  popupStyle={{ backgroundColor: 'lightcyan' }}
                  size="large"
                  onChange={onChangeHolidaydate}
                  style={{ width: '100%' }}
                  placeholder="Holiday date"
                ></DatePicker>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="local_holiday_name"
                label={word['Local_holiday_name']}
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Please enter local holiday name',
                  },
                ]}
              >
                <Input placeholder="Local holiday name" size="large"></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="english_holiday_name"
                label={word['English_holiday_name']}
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Please enter english holiday name',
                  },
                ]}
              >
                <Input placeholder="English holiday name" size="large"></Input>
              </Form.Item>

              <Form.Item name="create_by" label={word['Create_by']}>
                <Input placeholder="Create by" disabled size="large"></Input>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="remark" label={word['Remark']}>
                <TextArea
                  placeholder="Remark"
                  size="large"
                  style={{ minHeight: 135 }}
                ></TextArea>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="create_date" label={word["Create_date"]}>
                <DatePicker disabled style={{ width: '100%' }} size="large" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="last_update_date" label={word["Last_update_date"]}>
                <DatePicker disabled style={{ width: '100%' }} size="large" />
              </Form.Item>
            </Col>
          </Row>
        </fieldset>
      </Form>
    </Modal>
  )
}
export default AddTaskKPIFinance
